/*
 * File: index.tsx
 * Project: mp-mobile-app
 *
 * Created by Cole on 05/19/2021
 *
 * Copyright (c) 2021 MacPractice, Inc. All rights reserved.
 *
 * Description: The main entry point for the app
 */

import React from "react";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "typeface-roboto";
import "animate.css";
import rootDir from "./RootDir";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import grey from "@material-ui/core/colors/grey";
import red from "@material-ui/core/colors/red";
import "./ThemeExt";
import { ErrorBoundary } from "./ErrorBoundary";
import "./DebugHelpers";

const customTheme = createMuiTheme({
  typography: {
    button: {
      textTransform: "none",
      fontSize: "1rem",
      fontWeight: 500
    },

    fontWeightLight: 200,
    fontWeightRegular: 300,
    fontWeightMedium: 400,
    fontWeightBold: 900
  },
  divider: {
    main: grey[300]
  },
  palette: {
    primary: {
      main: "#29aae1"
    },
    secondary: {
      main: "#1F6A96"
    },
    error: {
      main: red[500]
    },
    common: {
      buttonGradient: "linear-gradient(45deg, #29aae1, #1F6A96) !important;",
      title: grey[800],
      label: grey[900],
      subtitle: grey[700],
      text: grey[800],
      border: grey[300],
      popupbg: grey[200],
      cardbg: grey[50],
      headerbg: grey[200],
      icons: grey[700],
      missed: "#B71C1C",
      cancelled: "#1F6A96",
      rescheduled: "#7446AA",
      tableHeader: "#F1F1F1"
    }
  }
});

render(
  <BrowserRouter basename={rootDir.path || ""}>
    <MuiThemeProvider theme={customTheme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        {/* Top level error boundary. Most errors should be caught by the boundary inside App. See the comment on the ErrorBoundary in App for more information about why we need both. */}
        <ErrorBoundary>
          <App
            // Set the app instance on the window to allow access to it from the developer console
            ref={app => (window._app = app ?? undefined)}
          />
        </ErrorBoundary>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  </BrowserRouter>,
  document.querySelector("#mpMobileApp")
);
